import React, { forwardRef, useRef } from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default withTranslation()(function CampaignRowActions({ t, campaign, isPaused, canPause, canDelete, onViewDetails, onPreview, onTogglePause, onDelete }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, forwardedRef) => {
        // ClickAwayListener may hand us a callback ref (no `.current`), so keep our
        // own object ref to measure the trigger's position for the fixed-position menu.
        const localRef = useRef(null)
        const setRefs = (node) => {
          localRef.current = node
          if (typeof forwardedRef === 'function') forwardedRef(node)
          else if (forwardedRef) forwardedRef.current = node
        }
        const rect = open && localRef.current ? localRef.current.getBoundingClientRect() : null

        return (
          <div className="relative" ref={setRefs}>
            <button
              type="button"
              onClick={handleClick}
              className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background"
            >
              <UIcons.UilEllipsisV size={18} className="text-secondary" />
            </button>

            {
              rect && (
                // position: fixed (rather than absolute) so the menu escapes the
                // table's horizontal-scroll wrapper instead of being clipped by it
                <div
                  className="fixed z-50 w-40 bg-white border border-border-lines rounded-xl shadow-lg py-2"
                  style={{ top: rect.bottom + 4, left: rect.right - 160 }}
                >
                  <button
                    type="button"
                    onClick={() => { onViewDetails(campaign); handleClick() }}
                    className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-dark-blue hover:bg-background"
                  >
                    <UIcons.UilFileAlt size={16} /> {t('promo.listing.actions.view_details')}
                  </button>

                  <button
                    type="button"
                    onClick={() => { onPreview(campaign); handleClick() }}
                    className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-dark-blue hover:bg-background"
                  >
                    <UIcons.UilEye size={16} /> {t('promo.listing.actions.preview')}
                  </button>

                  {
                    canPause && (
                      <button
                        type="button"
                        onClick={() => { onTogglePause(campaign); handleClick() }}
                        className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-dark-blue hover:bg-background"
                      >
                        <UIcons.UilPause size={16} /> {isPaused ? t('promo.listing.actions.resume') : t('promo.listing.actions.pause')}
                      </button>
                    )
                  }

                  {
                    canDelete && (
                      <button
                        type="button"
                        onClick={() => { onDelete(campaign); handleClick() }}
                        className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-danger hover:bg-background"
                      >
                        <UIcons.UilTrashAlt size={16} /> {t('promo.listing.actions.delete')}
                      </button>
                    )
                  }
                </div>
              )
            }
          </div>
        )
      })}
    />
  )
})
